// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileIcon {
  font-size: 36px;
  cursor: pointer;
}

.profile-menu {
  position: relative;
}

.profile-submenu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #ffd65f;
  min-width: 160px;
  box-shadow: 3px 2px 8px rgba(0, 0, 0, 0.5);
}

.profile-submenu li {
  display: block;
  padding: 0.5rem 1rem;
}

.profile-submenu li:hover {
  background-color: #ffd65f;
  color: #121212;
}

.profile-submenu li a {
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}

.profile-submenu li:hover a {
  color: #121212;
}

.profile-Photo {
  font-size: 100px;
  background-color: #fff;
  border: 1px solid #333;
  border-radius: 0.65rem;
  margin-top: -50px;
  margin-left: 24px;
}

.profile-container {
  display: flex;
  gap: 1rem;
}

.profile-name {
  font-weight: 600;
}

.form-list {
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

.form-list li {
  width: calc(33% - 1rem);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-list li span {
  border: 1px solid rgba(0, 0, 0, 0.35);
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  height: 36px;
  font-weight: 600;
}

.table {
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  table-layout: fixed;
}

.settings-th {
  --bs-table-bg: #0953c4;
  --bs-table-color: #fff;
}

@media (max-width: 768px) {
  body::after,
  body::before {
    content: none;
  }
  .count-boxes,
  .category-boxes {
    flex-direction: column;
  }
  .count-card,
  .catergory-item {
    width: 100%;
  }
  .form-list {
    flex-direction: column;
  }
  .form-list li {
    width: 100%;
  }
  .cover-photo {
    width: 100%;
    height: auto;
  }
  .table {
    width: 100%;
    min-width: 900px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Settings.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0CAAA;AAGF;;AADA;EACE,cAAA;EACA,oBAAA;AAIF;;AAFA;EACE,yBAAA;EACA,cAAA;AAKF;;AAHA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AAQF;;AANA;EACE,aAAA;EACA,SAAA;AASF;;AAPA;EACE,gBAAA;AAUF;;AARA;EACE,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAWF;;AATA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAYF;;AAVA;EACE,qCAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAaF;;AAXA;EACE,mBAAA;EACA,oCAAA;EACA,mBAAA;AAcF;;AAZA;EACE,sBAAA;EACA,sBAAA;AAeF;;AAZA;EACE;;IAEE,aAAA;EAeF;EAbA;;IAEE,sBAAA;EAeF;EAbA;;IAEE,WAAA;EAeF;EAbA;IACE,sBAAA;EAeF;EAbA;IACE,WAAA;EAeF;EAbA;IACE,WAAA;IACA,YAAA;EAeF;EAbA;IACE,WAAA;IACA,gBAAA;EAeF;AACF","sourcesContent":[".profileIcon {\r\n  font-size: 36px;\r\n  cursor: pointer;\r\n}\r\n.profile-menu {\r\n  position: relative;\r\n}\r\n.profile-submenu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background-color: #fff;\r\n  padding: 1rem;\r\n  border-radius: 6px;\r\n  border: 1px solid #ffd65f;\r\n  min-width: 160px;\r\n  box-shadow: 3px 2px 8px rgba(0, 0, 0, 0.5);\r\n}\r\n.profile-submenu li {\r\n  display: block;\r\n  padding: 0.5rem 1rem;\r\n}\r\n.profile-submenu li:hover {\r\n  background-color: #ffd65f;\r\n  color: #121212;\r\n}\r\n.profile-submenu li a {\r\n  text-decoration: none;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #333;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n.profile-submenu li:hover a {\r\n  color: #121212;\r\n}\r\n.profile-Photo {\r\n  font-size: 100px;\r\n  background-color: #fff;\r\n  border: 1px solid #333;\r\n  border-radius: 0.65rem;\r\n  margin-top: -50px;\r\n  margin-left: 24px;\r\n}\r\n.profile-container {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n.profile-name {\r\n  font-weight: 600;\r\n}\r\n.form-list {\r\n  padding-left: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n.form-list li {\r\n  width: calc(33% - 1rem);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n.form-list li span {\r\n  border: 1px solid rgba(0, 0, 0, 0.35);\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 0.25rem;\r\n  height: 36px;\r\n  font-weight: 600;\r\n}\r\n.table {\r\n  border-radius: 20px;\r\n  border: 1px solid rgba(0, 0, 0, 0.4);\r\n  table-layout: fixed;\r\n}\r\n.settings-th {\r\n  --bs-table-bg: #0953c4;\r\n  --bs-table-color: #fff;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  body::after,\r\n  body::before {\r\n    content: none;\r\n  }\r\n  .count-boxes,\r\n  .category-boxes {\r\n    flex-direction: column;\r\n  }\r\n  .count-card,\r\n  .catergory-item {\r\n    width: 100%;\r\n  }\r\n  .form-list {\r\n    flex-direction: column;\r\n  }\r\n  .form-list li {\r\n    width: 100%;\r\n  }\r\n  .cover-photo {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .table {\r\n    width: 100%;\r\n    min-width: 900px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
